export const CULTURE_STORAGE_KEY = 'selectedCulture';
